class ContentBlock extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.js-content-block-swiper')
    const option = {
      init: false,
      spaceBetween: 15,
      slidesPerView: 1.5,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 15,
      slidesOffsetBefore: 15,
      slidesPerGroup: 1,
      navigation: {
        nextEl: '.content-block--icon-next',
        prevEl: '.content-block--icon-previous',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar'
      },
      breakpoints: {
        640: {
          slidesPerView: 2.5,
        },
        1024: {
          spaceBetween: 30,
          slidesPerView: 3.5,
          slidesOffsetAfter: 60,
          slidesOffsetBefore: 60,
        },
        1200: {
          navigation: false,
          pagination: false,
          spaceBetween: 30,
          slidesPerView: 4,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          enabled: false
        },
      },
    }

    this.$swiper = new Swiper(swiperEl, option)
    this.$swiper.init()
  }

  disconnectedCallback() {
    if (this.$swiper && typeof this.$swiper.destroy === 'function') {
      this.$swiper.destroy(true, true)
    }
  }
}

customElements.define('content-block', ContentBlock)
